import { Notify } from 'quasar'

export default {
  showSpinner({ commit }, message) {
    commit('set', ['spinnerMessage', message || 'Loading...'])
  },

  hideSpinner({ commit }) {
    commit('set', ['spinnerMessage', null])
  },

  resetSidebar({ commit }) {
    // The sidebar utilises three Vuex fields (sidebarRecords, sidebarSearch & sidebarTags). It is convenient
    // to reset these all together when navigating between root navigation options (e.g. quotes to services),
    // as the sidebar information from one will no longer be applicable to the other.
    commit('set', ['sidebarRecords', []])
    commit('set', ['sidebarSearch', ''])
    commit('set', ['sidebarTags', []])
  },

  confirm({ commit }, { text, detail, okText, cancelText, icon, catchCancel }) {
    /*
      Shows a confirmation dialog and returns a promise. Parameters:

      - text (string): Primary message text
      - detail (string): Optional secondary message text
      - okText (string): Optional text for the confirm button (defaults to "OK")
      - cancelText (string): Optional cancel button text (defaults to "Cancel"). If set to null or empty, no cancel button is displayed.
      - icon (string): Optional icon name (from Material Icons) to use for the main icon. Otherwise a question mark icon will be used if the confirmation has confirm & cancel buttons, and otherwise an info icon will be used.
      - catchCancel (boolean): If true, "cancel" events will trigger the catch() block (i.e. reject the promise). This is off by default because otherwise every Confirm would need a catch().
    */
    return new Promise((resolve, reject) => {
      commit('set', [
        'confirm',
        {
          text,
          detail,
          icon,
          okText,
          cancelText,
          catchCancel,

          onConfirm() {
            commit('set', ['confirm', null])
            resolve()
          },
          onCancel(catchCancel) {
            commit('set', ['confirm', null])
            if (catchCancel) {
              reject()
            }
          }
        }
      ])
    })
  },

  notify(store, { message, type, timeout }) {
    /*
        Shows a quick notification (toast / snackbar etc).

          params <object>:
            message <string>: Notification message text
            type <string>: Optional display type. Either "positive", "negative", "info" or "warning".
            timeout <number>: Optional timeout (defaults to 5000)
      */

    if (message) {
      Notify.create({
        type: type || 'positive',
        message: message,
        timeout: timeout || 5000
      })
    }
  }
}
